import { ComponentType } from 'react';
import { Endpoint } from '../types';
import { APVSelectPage } from '../endpoints/apv-select';
import { APVSelectOnePage } from '../endpoints/apv-select-one';
import { FamilySavingsInsurancePage } from '../endpoints/family-savings-insurance';
import { InsuredUniversityPage } from '../endpoints/insured-university';
import { LifeMaxPage } from '../endpoints/life-max';

export interface EndpointPageProps {
  endpoint: Endpoint;
}

export const PAGE_REGISTRY: Record<string, ComponentType<EndpointPageProps>> = {
  'family-savings-insurance': FamilySavingsInsurancePage,
  'insured-university': InsuredUniversityPage,
  'apv-select': APVSelectPage,
  'life-max': LifeMaxPage,
  'apv-select-one': APVSelectOnePage,
};
